import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { ADDRESS_VALIDATION_ERROR_KEYS } from './address-field.validators';

/** Maximum length for phone extension fields (legacy OLS txtExt MaxLength). */
export const PHONE_EXTENSION_MAX_LENGTH = 6;

/** Allows digits only. */
export const PHONE_EXTENSION_DIGITS_REGEX = /^\d*$/;

/**
 * Returns whether the value is blank or contains digits only.
 */
export function isValidPhoneExtensionText(value: string): boolean {
  return PHONE_EXTENSION_DIGITS_REGEX.test(value);
}

/**
 * Validates optional phone extensions when a non-blank value is present.
 */
export function optionalPhoneExtensionValidator(control: AbstractControl): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value.trim() : '';

  if (!value) {
    return null;
  }

  return isValidPhoneExtensionText(value)
    ? null
    : { [ADDRESS_VALIDATION_ERROR_KEYS.phoneExtensionNonNumeric]: true };
}

/**
 * Requires a phone number when an extension value is present (OM-45 scenario 19).
 */
export function phoneExtensionRequiresPhoneValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const extension = typeof control.value === 'string' ? control.value.trim() : '';

  if (!extension) {
    return null;
  }

  const phoneValue = control.parent?.get('phoneNumber')?.value;
  const phone = typeof phoneValue === 'string' ? phoneValue.trim() : '';

  return phone
    ? null
    : { [ADDRESS_VALIDATION_ERROR_KEYS.phoneExtensionRequiresPhone]: true };
}
